export default __webpack_public_path__ + "assets/images/aff0fc03ed75e45ee06c01013797212c.svg";